/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';

@Injectable()
export class LiftContainer {
  private container: HTMLElement;
  private overlayParent: HTMLElement | null = null;

  showOverlay(liftParentElement?: HTMLElement | null): void {
    this.overlayParent = liftParentElement || null;
    const container = this.getContainerElement();
    container.classList.add('raised');
    if (this.overlayParent) {
      this.overlayParent.classList.add('lift-overlay-active');
    } else {
      document.body.classList.add('lift-overlay-active');
    }
  }

  hideOverlay(): void {
    const container = this.getContainerElement();
    container.classList.remove('raised');
    if (this.overlayParent) {
      this.overlayParent.classList.remove('lift-overlay-active');
      this.overlayParent = null;
    }
    document.body.classList.remove('lift-overlay-active');
  }

  private getContainerElement(): HTMLElement {
    let { container } = this;

    if (!container) {
      this.container = container = document.createElement('div');
      container.classList.add('lift-container');
      const parent = this.overlayParent || document.body;
      parent.insertBefore(container, parent.firstChild);
    } else if (this.overlayParent && container.parentElement !== this.overlayParent) {
      this.overlayParent.insertBefore(container, this.overlayParent.firstChild);
    } else if (!this.overlayParent && container.parentElement !== document.body) {
      document.body.appendChild(container);
    }

    return container;
  }
}
